export default __webpack_public_path__ + "static/media/me.11aba5ce.jpg";